import { render, staticRenderFns } from "./rc-crm-notes.vue?vue&type=template&id=444c782d&scoped=true&"
import script from "./rc-crm-notes.vue?vue&type=script&lang=js&"
export * from "./rc-crm-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444c782d",
  null
  
)

export default component.exports